import React from 'react';
import { useLanguage } from '../context/LanguageContext';

const MissionSection = () => {
  const { t } = useLanguage();

  return (
    <section id="mission" className="bg-[#1a1c1b] py-20 md:py-28">
      <div className="max-w-[87.5rem] mx-auto px-6 md:px-10">
        <div className="flex flex-col lg:flex-row gap-12 lg:gap-16 items-center">
          {/* Icon/Illustration */}
          <div className="flex-shrink-0">
            <div className="w-28 h-28 md:w-36 md:h-36 rounded-full border border-[#3f4816] flex items-center justify-center relative">
              <div className="absolute inset-0 rounded-full border border-[#d9fb06]/10" style={{ transform: 'scale(1.3)' }} />
              <div className="absolute inset-0 rounded-full border border-[#d9fb06]/5" style={{ transform: 'scale(1.6)' }} />
              <svg className="w-14 h-14 md:w-18 md:h-18 text-[#d9fb06]" viewBox="0 0 80 80" fill="none">
                <circle cx="40" cy="40" r="12" stroke="currentColor" strokeWidth="2" />
                <circle cx="40" cy="40" r="4" fill="currentColor" />
                <circle cx="40" cy="12" r="5" stroke="currentColor" strokeWidth="1.5" />
                <circle cx="64" cy="28" r="5" stroke="currentColor" strokeWidth="1.5" />
                <circle cx="64" cy="52" r="5" stroke="currentColor" strokeWidth="1.5" />
                <circle cx="40" cy="68" r="5" stroke="currentColor" strokeWidth="1.5" />
                <circle cx="16" cy="52" r="5" stroke="currentColor" strokeWidth="1.5" />
                <circle cx="16" cy="28" r="5" stroke="currentColor" strokeWidth="1.5" />
                <line x1="40" y1="28" x2="40" y2="17" stroke="currentColor" strokeWidth="1" opacity="0.6" />
                <line x1="50" y1="34" x2="59" y2="30" stroke="currentColor" strokeWidth="1" opacity="0.6" />
                <line x1="50" y1="46" x2="59" y2="50" stroke="currentColor" strokeWidth="1" opacity="0.6" />
                <line x1="40" y1="52" x2="40" y2="63" stroke="currentColor" strokeWidth="1" opacity="0.6" />
                <line x1="30" y1="46" x2="21" y2="50" stroke="currentColor" strokeWidth="1" opacity="0.6" />
                <line x1="30" y1="34" x2="21" y2="30" stroke="currentColor" strokeWidth="1" opacity="0.6" />
              </svg>
            </div>
          </div>

          {/* Content */}
          <div className="flex-1 text-center lg:text-left">
            <h2 className="font-black text-[#d9fb06] text-3xl sm:text-4xl md:text-5xl lg:text-6xl uppercase leading-[0.85] mb-6">
              {t.mission.title}
            </h2>
            <p className="text-[#888680] text-base md:text-lg lg:text-xl leading-relaxed max-w-3xl">
              {t.mission.description}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default MissionSection;
